//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'CustomTransition',
  props: {
    name: String,
    appear: Boolean
  },
  methods: {
    beforeEnter: function beforeEnter(el) {
      this.$emit('beforeEnter', el);
      this.$emit('beforeTransition', el);
    },
    afterEnter: function afterEnter(el) {
      this.$emit('afterEnter', el);
      this.$emit('afterTransition', el);
    }
  }
};